import { ReactElement, useMemo, memo } from 'react';
import { Stack, Typography } from '@mui/material';

import { ZoneSaturationLevelType } from '~globals/types/enums';
import { formatNumber } from '~utils/formatter';

import { getZoneSaturationLevelColor } from '../../../../../utils';
import { DashboardVariantV2CarrierZoneSaturationTableOccupancyInfoProgressBar } from './styles';

interface DashboardVariantV2CarrierZoneSaturationTableOccupancyInfoCellProps {
  levelTypeId: ZoneSaturationLevelType;
  capacity: number;
  occupancyPercentage: number;
}

const DashboardVariantV2CarrierZoneSaturationTableOccupancyInfoCell = ({
  levelTypeId,
  capacity,
  occupancyPercentage,
}: DashboardVariantV2CarrierZoneSaturationTableOccupancyInfoCellProps): ReactElement => {
  const color = useMemo(
    () => getZoneSaturationLevelColor(levelTypeId),
    [levelTypeId],
  );

  if (capacity === 0) {
    return (
      <Typography variant="caption" color="text.secondary" fontWeight="bold">
        Sin choferes asignados
      </Typography>
    );
  }

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <DashboardVariantV2CarrierZoneSaturationTableOccupancyInfoProgressBar
        variant="determinate"
        value={Math.min(occupancyPercentage, 100)}
        customColor={color}
      />

      <Typography
        variant="caption"
        color={color}
        fontWeight="bold"
        minWidth={38}
      >
        {`${formatNumber(occupancyPercentage)}%`}
      </Typography>
    </Stack>
  );
};

export default memo(
  DashboardVariantV2CarrierZoneSaturationTableOccupancyInfoCell,
);
